// extracted by mini-css-extract-plugin
module.exports = {"desktopOnly":"Ac4Amf2rfmQhEOrZdK3B0","mobileOnly":"_1oz8E2CScUnT6BXHidEav","rankCell":"_24oJzEkNPQ2L9_TT6GOZaH"};